import clone from 'fast-clone';
import { getNodeId } from '../store/actionHandlers/common/adapterActions';

export default class NodeClassNames {
  constructor({ nodeClassName = () => null }) {
    this._nodeClassName = nodeClassName;
  }

  get key() {
    return 'nodeClassNames';
  }

  prepareTreeState(treeState) {
    treeState.nodeClassNames = {};
  }

  handleDidAddModels(treeState, models, { adapter, plugins: { nodesMeta } }) {
    const classesToAdd = models.reduce((hash, model) => {
      const id = getNodeId(adapter, model);
      const meta = nodesMeta ? nodesMeta.getNodesMeta(treeState, id) : null;

      const className = this._nodeClassName(model, meta);
      if (className) {
        hash[id] = className;
      }

      return hash;
    }, {});

    const nodeIds = Object.keys(classesToAdd);
    if (nodeIds.length) {
      const nodeClassNames = clone(treeState.nodeClassNames);

      for (const nodeId of nodeIds) {
        nodeClassNames[nodeId] = classesToAdd[nodeId];
      }

      treeState.nodeClassNames = nodeClassNames;
    }
  }

  handleDidChangeModels(
    treeState,
    changedModels,
    { adapter, plugins: { nodesMeta } },
  ) {
    const changes = {};

    for (const model of changedModels) {
      const id = getNodeId(adapter, model);
      const meta = nodesMeta ? nodesMeta.getNodesMeta(treeState, id) : null;

      const className = this._nodeClassName(model, meta) || null;
      const oldClassName = treeState.nodeClassNames[id] || null;

      if (className !== oldClassName) {
        changes[id] = className;
      }
    }

    const nodeIds = Object.keys(changes);
    if (nodeIds.length) {
      const nodeClassNames = clone(treeState.nodeClassNames);

      for (const nodeId of nodeIds) {
        const className = changes[nodeId];

        if (className) {
          nodeClassNames[nodeId] = className;
        } else {
          delete nodeClassNames[nodeId];
        }
      }

      treeState.nodeClassNames = nodeClassNames;
    }
  }

  handleDidRemoveModels(treeState, modelIdsSet) {
    const idsToRemove = Array.from(modelIdsSet).filter(
      id => !!treeState.nodeClassNames[id],
    );

    if (idsToRemove.length) {
      const nodeClassNames = clone(treeState.nodeClassNames);
      idsToRemove.forEach(id => delete nodeClassNames[id]);
      treeState.nodeClassNames = nodeClassNames;
    }
  }

  getNodeClassName(treeState, nodeId) {
    return treeState.nodeClassNames[nodeId] || null;
  }
}
